import { Tooltip } from 'primereact/tooltip';
import { ReactNode } from 'react';
import { PanelProps } from '../Panel';

export function TooltipHeader(props: PanelProps): ReactNode | null {
    if (!props.tooltip) {
        return null;
    }

    return (
        <>
            <Tooltip target="#panel-tooltip-title" />
            <span
                id="panel-tooltip-title"
                data-pr-position="left"
                data-pr-tooltip={props.tooltip}
            >
                {props.header}
            </span>
        </>
    );
}
